import shared from "emun.report/_labels.es6";

export default Object.assign(shared, {
  warehouses: '',
  productLines: '',
});